namespace Matrix.Common {
    export class UserPreferenceStorage implements Serenity.SettingStorage {
        getItem(key: string): string {
            let value: string;

            UserPreferenceService.Retrieve({
                PreferenceTypeCode: "UserPreferenceStorage",
                PreferenceName: key
            },
            response => value = response.Value,
            {
                async: false
            });

            return value;
        }

        setItem(key: string, data: string): void {
            UserPreferenceService.Update({
                PreferenceTypeCode: "UserPreferenceStorage",
                PreferenceName: key,
                Value: data,
            }, response => { }, {
                async: false
            });
        }
    }
}